








import {Component, Prop, Vue} from "vue-property-decorator";
import {LadingCode} from "@/interfaces/entity";

@Component({
    name: "LadingCodePrint"
})
export default class extends Vue {
    @Prop({ type: Number, default: 6 }) readonly colSpan!: number;
    @Prop({ type: Array, default: [] }) readonly ladingCodes!: Array<LadingCode>;
}
